// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2Y9j9","ranges":"BmiRanges_ranges__GWE-V"};